<template>
  <div
    class="d-flex justify-content-center align-items-center loader-container"
  >
    <img
      data-aos="flip-left"
      src="../../assets/images/home/logo-light.svg"
      class="img-fluid"
      alt="image"
      height=""
    />
  </div>
</template>

<script>
import AOS from "aos";
export default {
  name: "Preloader",
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
<style lang="scss" scoped>
.loader-container {
  width: 100%;
  height: 100vh;
  background: #062b3b;
}

.loader {
  display: inline-grid;
  width: 40px;
  aspect-ratio: 1;
}

.loader:before,
.loader:after {
  content: "";
  grid-area: 1/1;
  border-radius: 50%;
  background: repeating-conic-gradient(#c02942 0 60deg, #0b486b 0 120deg);
}

.loader:before {
  transform: rotate(0turn) translate(100%) rotate(0turn);
  animation: l5 4s linear infinite;
}

.loader:after {
  padding: 20%;
  mask: conic-gradient(#000 0 0) content-box exclude, conic-gradient(#000 0 0);
  scale: -1 1;
}

@keyframes l5 {
  to {
    transform: rotate(1turn) translate(100%) rotate(1turn);
  }
}
</style>
